<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="" v-if="!mantenimiento">
      <!-- <v-row> -->


      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
         <v-btn
            class="mx-2"
            fab
            dark
            small
            color="success"
            @click="$router.go(-1)"
            v-if="user && user.IDStB"
          >
            <v-icon dark>
              mdi-keyboard-backspace
            </v-icon>
          </v-btn>
          <br/><br/>
          <div
                class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
              >{{ title }}</div>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <v-select
                v-model="curso"
                :items="cursos"
                item-text="cruso_data.Feriado"
                item-value="cruso_data.IDF"
                label="Selecciona el curso a pagar"
                persistent-hint
                return-object
                single-line
                v-on:change="loadData"
              ></v-select>
            </v-col>
        </v-row>
         <div v-if="curso"><br/>
          <h2>
            Selecciona lo que pagarás
          </h2>
          <v-simple-table >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Valor regular
                  </th>
                  <th class="text-left">
                    Concepto
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                

                <tr v-for="(pagoData,
                  pagoKey) in pagos.items"
                  :key="pagoKey"
                  
                  v-show="pagoData.statusPago != 'Pendiente: Pendiente Verificar' "
                  >

                  <td v-bind:style="colorText(pagoData)" v-if="canPay(pagoData)">
                    <span style="margin-right: 20px;">${{pagoData.precioAPagar}}</span>

                     <v-badge
                      :content="'Beca ' + pagoData.beca + '%'"
                      :value="messages"
                      color="green"
                      v-if="pagoData.beca != 0"
                    >
                    </v-badge>
                  </td>
                  <td v-bind:style="colorText(pagoData)" v-if="pagoData.pagado">${{pagoData.precioPagado}}</td>
                  <td v-bind:style="colorText(pagoData)" v-else-if="pagoData.block">${{pagoData.precioAPagar}}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.Materia }}</td>
                  <td>
                    <v-checkbox
                      v-if="canPay(pagoData)"
                      v-model="pagoData.check"
                      @change="changeTotal(pagoData, pagoKey)"
                    ></v-checkbox>
                  </td>
                  
                </tr>
                  
                
                
                <tr style="background-color: orange; color: white;">
                  <td><strong>COMISIÓN DE PLATAFORMA</strong>div</td>
                  <td><strong>0%</strong></td>
                  <td></td>
                </tr>

                <tr style="background-color: green; color: white;">
                  <td><strong>TOTAL</strong></td>
                  <td><strong>${{total}}</strong></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <br/>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="pay()"
              :disabled="total == 0"
              >Efectuar pago</v-btn
            >
            </v-col>
          </v-row>
        </div>

      </v-col>

      <!-- </v-row> -->
    </CardIeaAppMain>
    <CardIeaAppMain colorCard="#A7BA38" title="" v-else>
     <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
         <v-btn
            class="mx-2"
            fab
            dark
            small
            color="success"
            @click="$router.go(-1)"
            v-if="user && user.IDStB"
          >
            <v-icon dark>
              mdi-keyboard-backspace
            </v-icon>
          </v-btn>
          <br/><br/>
        <v-alert
          prominent
          type="error"
        >
         Servicio en mantenimiento, pronto estaremos en linea, Gracias
        </v-alert>
        <v-text-field
            v-model="isadmin"
            label="Enter password"
            required
            @input="up"
          ></v-text-field>
      </v-col>
      
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";


export default {
  name: "PaymentCurso",
  components: {
    // CardIeaApp,
    CardIeaAppMain,

    
  },

  data: function() {
    return {
      title:"Efectuar pago",
      curso: null,
      cursos:[],
      pagos:[],
      total:0,
      items:[],
      urlPay : '',
      mantenimiento:false,
      isadmin:''
      
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  mounted() {
    this.$API
      .get({
        url: "alumno/cursos",
        data: {},
      })
      .then((res) => {
        this.cursos = res;
      })
      .catch((err) => {
        console.log(err);
    });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps
      console.log(this.$refs.calendar)
      
      if(datos.turno_id && !datos.block){
        this.dialog = true
        this.turno_id = datos.turno_id;
      }
    },
    up (){
      if (this.isadmin == 'adminadmin') {
        this.mantenimiento = false;    
      }
    },
   
    async loadData() {
      console.log(this.curso.Curso)
      this.$API
        .get({
          url: "listado-pagos/" + this.curso.Curso,
          data: {},
        })
        .then((res) => {
          console.log(res)
          //let r = res.items.map((value) => {return {...value, precioAPagarDesc:value.precioAPagar - ((value.precioAPagar * res.descuento)/100)}})
          //res.items = r;
          this.pagos = res;
          this.total = 0;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    colorText(pagoData) {
      let color = 'black';
      if(pagoData.block){
        color = '#888';
      }
      if(pagoData.pagado){
        color = 'green';
      }
      return {color:color}
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    changeTotal(pagoData, index) {
      console.log(pagoData)
      pagoData.index = index;
      if(pagoData.check){
        this.total += parseFloat(pagoData.precioAPagar)
      }else{
        this.total -= parseFloat(pagoData.precioAPagar);
      }
      let selecteds = this.pagos.items.filter(d => {return d.check;})
      this.items = selecteds.map((value) => {return {id: value.IDStB, monto: value.precioAPagarDesc, index:value.index }})
      console.log(this.items)
    },
    
    async pay() {
      let dataSend = {
        curso:this.curso.Curso,
        items:this.items
      };

      let url = "plan-de-pago/pagar";
     
      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          this.urlPay = res;
          
          location.href = res
          
        });
    }
  }
};
</script>
